import React, { Component } from "react";
import FormField from "../appForm/FormField";
import { injectIntl, defineMessages } from "react-intl";
import { commonMessages } from "../../translations/commonMessages";
import PropTypes from "prop-types";

const messages = defineMessages({
  personalPrivacyDescription: {
    id: "personalPrivacyDescription",
    defaultMessage: `Apps that you add are considered personal and are never shared with your employer.`
  },
  companyPrivacyDescription: {
    id: "companyPrivacyDescription",
    defaultMessage: `Company apps are added to the catalog and are eligible for your account admin to make available to other users in your organization.`
  }
});

const PERSONAL = "personal";
const COMPANY = "company";

export class PrivacySelectorFormField extends Component {
  onPrivacyChange = event => {
    this.props.onChange({
      id: this.props.id,
      value: event.value === PERSONAL
    });
  };

  render() {
    const { intl, isPrivate } = this.props;

    //NOTE: selector is not designed to be readonly/disabled
    return (
      <div>
        <FormField
          field={{
            name: "privacy",
            type: "radio",
            id: PERSONAL,
            label: intl.formatMessage(commonMessages.personal),
            description: intl.formatMessage(
              messages.personalPrivacyDescription
            ),
            value: PERSONAL,
            checked: isPrivate ? "checked" : "",
            onChange: this.onPrivacyChange,
            disabled: false,
            readOnly: false
          }}
          showCopy={false}
        />
        <FormField
          field={{
            name: "privacy",
            type: "radio",
            id: COMPANY,
            label: intl.formatMessage(commonMessages.company),
            description: intl.formatMessage(messages.companyPrivacyDescription),
            value: COMPANY,
            checked: isPrivate ? "" : "checked",
            onChange: this.onPrivacyChange,
            disabled: false,
            readOnly: false
          }}
          showCopy={false}
        />
      </div>
    );
  }
}

PrivacySelectorFormField.propTypes = {
  onChange: PropTypes.func.isRequired,
  isPrivate: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired
};

export default injectIntl(PrivacySelectorFormField);
